
export default class Helpers {

  static getSiblings = function (elem) {
    return Array.from(elem.parentNode.children).filter(function (sibling) {
      return sibling !== elem;
    });
  }
  
  static getCookie = function (name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();
  }

  static setCookie = function(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  static getDiscountSession = function() {
    var discount = sessionStorage.getItem("discount");
    if (typeof discount === "string" && discount.length && discount !== "FALSE") {
      return discount;
    }
    return false;
  }

  static setDiscountSession =  function(){
    sessionStorage.setItem("discount", value ? value : "FALSE");
  }


  static getDiscount = function() {
    if (
      !Helpers.getDiscountSession() ||
      getCookie("discount_code") !== getDiscountSession()
    ) {
      //(typeof sessionStorage.getItem('discount') === 'undefined' || sessionStorage.getItem('discount') === null || sessionStorage.getItem('discount') === 'FALSE') {
      var cookie = Helpers.getCookie("discount_code");
      if (cookie && cookie !== "") {
        return fetch(
          "/apps/discountz-api/discount-info",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ code: cookie }),
          }
        )
          .then(function (response) {
            return response.status === 200 ? response.json() : null;
          })
          .then(function (result) {
            if (result && result.status === "ACTIVE") {
              Helpers.setCookie("discount_code", cookie, 365);
              // Helpers.setDiscountSession(cookie);
              return cookie;
            } else {
              Helpers.setCookie("discount_code", "", 365);
              // Helpers.setDiscountSession(false);
              return false;
            }
          });
      }
    }
    return Promise.resolve(Helpers.getDiscountSession());
  }

  static setBannerShouldShow = function(id, shouldShow) {
    sessionStorage.setItem("banner-" + id, shouldShow ? "yes" : "no");
  }

  static async updateCartAttributes(discountCode, discountAmount, discountedTotal, refresh) {
    return fetch(
      "/cart/update.js",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(
          { 
            attributes: {
              'discount_code': discountCode,
              'discount_amount': discountAmount,
              'discounted_total': discountedTotal
            } 
          }),
      }
    ).then(function (cart) {
      cart.json().then(function (content) {
        if (refresh == true) {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: {
              // this will indicate that the discount was refreshed and 
              // doese not neet to be checked again 
              discountz: true
            }
          }));
        }
      })
    })
  }

  static async addCartItems(itemsObject){
    try {
      let response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(itemsObject)
      })
      // If not successful
      if ( response.status != 200 ) {
        response.json().then(function (content) {
          console.log('error, something went wrong:', content);
        });
      } 
      return response
    } catch(e) {
      console.log(e);
    }
  }
  static async removeCartItem(variantId){
    try {
      let response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          quantity: 0,
          id: variantId
        })
      })
      // If not successful
      if ( response.status != 200 ) {
        response.json().then(function (content) {
          console.log('error, something went wrong:', content);
        });
      } 
      return response
    } catch(e) {
      console.log(e);
    }
  }
}